import { MDBBtn } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useDarkMode } from "../assets/DarkModeContext";
import { http } from "../services/httpService";

const initialFormData = {
    id: null,
    categoryId: 0,
    competenceFr: '',
    competenceEn: '',
    descriptionFr: '',
    descriptionEn: '',
}

export default function AddNewCompetence(
    {
        categories,
        setCompetences,
        selectedLanguage,
    }
) {
    const [ formData, setFormData ] = useState( initialFormData );

    const { isDarkMode } = useDarkMode();

    const handleChange = ( event ) => {
        setFormData( prevState => {
            return {
                ...prevState,
                [ event.target.name ]: event.target.value
            }
        } );
    };

    const handleSubmit = async ( e ) => {
        e.preventDefault();

        if ( !formData.competenceEn || !formData.descriptionEn ) {
            toast.warning( "Remplissez les champs de traduction en anglais." );
            return;
        }

        try {
            const competenceToAdd = {
                id: formData.id,
                categoryId: formData.categoryId.valueOf,
                competenceTranslations: {
                    fr: formData.competenceFr,
                    en: formData.competenceEn,
                },
                descriptionTranslations: {
                    fr: formData.descriptionFr,
                    en: formData.descriptionEn,
                },
            };

            const response = await http(
                'ref/competences/add',
                {
                    method: 'POST',
                    body: JSON.stringify( competenceToAdd ),
                } );

            if ( !response.ok ) {
                const errorData = await response.json();
                throw new Error( errorData.message || "La compétence existe déjà." );
            }

            const data = await response.json();

            toast.success( "Compétence ajoutée avec succès" );

            setFormData( initialFormData );
            setCompetences( prevState => [
                ...prevState,
                data,
            ] );
        } catch ( error ) {
            console.error( 'Erreur lors de l’ajout de la compétence:', error );
            toast.warning( "Erreur lors de l'ajout de la compétence: " + error.message );
        }
    };

    return (
        <>
            <h5 className={ `text-center py-3 ${ isDarkMode ? 'text-white' : '' }` }>
                <strong>Ajouter une compétence</strong>
            </h5>
            <div className='container'>
                <form onSubmit={ handleSubmit }>
                    <div className='row justify-content-center'>
                        <div className='col-4 d-flex flex-column'>
                            <i className="flag flag-france"></i>
                            <input
                                type="text"
                                name="competenceFr"
                                value={ formData.competenceFr }
                                onChange={ handleChange }
                                placeholder="Nom"
                                style={ { padding: '10px', fontSize: '16px' } }
                                required
                            />
                            <textarea
                                name="descriptionFr"
                                value={ formData.descriptionFr }
                                onChange={ handleChange }
                                placeholder="Description"
                                style={ { padding: '10px' } }
                                className='mt-2'
                                required
                            />
                        </div>
                        <div className='col-4 d-flex flex-column'>
                            <i className="flag flag-united-kingdom"></i>
                            <input
                                type="text"
                                name="competenceEn"
                                value={ formData.competenceEn }
                                onChange={ handleChange }
                                placeholder="Name"
                                style={ { padding: '10px', fontSize: '16px' } }
                                required
                            />
                            <textarea
                                name="descriptionEn"
                                value={ formData.descriptionEn }
                                onChange={ handleChange }
                                placeholder="Description"
                                style={ { padding: '10px' } }
                                className='mt-2'
                                required
                            />
                        </div>
                        <div className='col-4 d-flex flex-column pt-2 justify-content-center gap-3'>
                            <select
                                name="categoryId"
                                value={ formData.categoryId }
                                onChange={ handleChange }
                                style={ { padding: '10px', fontSize: '16px' } }
                                className="w-full mt-2"
                                required
                            >
                                <option value="">Catégorie</option>
                                { categories
                                    .sort( ( a, b ) =>
                                        a.translations[ selectedLanguage ]
                                            .localeCompare( b.translations[ selectedLanguage ]
                                            ) )
                                    .map( ( category ) => (
                                        <option key={ category.id } value={ category.id }>
                                            { category.translations[ selectedLanguage ] }
                                        </option>
                                    ) ) }
                            </select>
                            <MDBBtn className="BtnCard w-full mt-2" type="submit"
                                    style={ { padding: '10px 15px', fontSize: '16px', cursor: 'pointer' } }>Ajouter</MDBBtn>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
